import {BaseSpringServiceCB} from "@aiknow-srl/aik-ngx-http";
import {DeviceTypeOPEEnum} from "./DeviceTypeOPEEnum";

class O {
  id!: number;
}

class I {
  deviceTypeId!: number;
  modelName!: string;
}

export class DuplicateDeviceTypeCB extends BaseSpringServiceCB {
  public i: I;
  public o: O;

  constructor() {
    super(DeviceTypeOPEEnum.DuplicateDeviceType);
    this.i = new I();
    this.o = new O();
  }
}
